import { useTranslation } from "react-i18next";
import { useSettings } from "./useSettings";

// AUD-C -- vocabulario por segmento.
//
// Uma oficina de moto nao deveria ler "Dados do veiculo" na tela. Em vez de
// espalhar `if (segmento === "moto")` por dezenas de pontos, este hook
// devolve um t() que procura primeiro a variante "<chave>_moto" e, quando
// ela NAO existe, cai na chave original.
//
// Consequencia pratica -- e o motivo de ter sido feito assim:
//   - so escrevo no JSON as chaves que realmente mudam;
//   - esquecer uma variante nao quebra nada, so mantem o texto atual;
//   - carro continua byte a byte como sempre foi, porque nenhuma chamada
//     t(...) individual foi alterada: trocou-se a FONTE do t, nao os usos.
//
// O segmento vem de oficina_config_<tenant>.checklistConfig.segmento, imposto
// pelo painel administrativo (ver components/ChecklistConfigGate.js).
export function useTextos() {
  const { t, i18n } = useTranslation();
  const { settings } = useSettings();
  const segmento = (settings && settings.segmento) || "carro";

  function tSegmento(chave, opcoes) {
    if (segmento === "moto" && typeof chave === "string") {
      const variante = chave + "_moto";
      // i18n.exists respeita o idioma ativo e o fallback configurado.
      if (i18n && typeof i18n.exists === "function" && i18n.exists(variante)) {
        return t(variante, opcoes);
      }
    }
    return t(chave, opcoes);
  }

  return { t: tSegmento, tBase: t, i18n, segmento };
}
